export const INFO = 'text';
export const TEST = 'test';
export const PHOTO = 'image_gallery';
export const VIDEO = 'youtube_video';
export const DIALOG = 'poll';
// export const PDF = 'pdf'
